import { IRequestModelWorkspaceFilter } from "@interfaces/reports/reports-common.interfaces";


export const isWorkspaceFilterValid = (applyFilter: boolean, filter: IRequestModelWorkspaceFilter | undefined) => {
    if (applyFilter)
        return !!filter?.property && !!filter?.operator && !!filter?.value;
    else
        return true;
}